export default {
    "US": {
        "id": "US",
        "two_letter_abbreviation": "US",
        "three_letter_abbreviation": "USA",
        "full_name_locale": "United States",
        "full_name_english": "United States",
        "available_regions": [
            {
                "id": "1",
                "code": "AL",
                "name": "Alabama"
            },
            {
                "id": "2",
                "code": "AK",
                "name": "Alaska"
            },
            {
                "id": "4",
                "code": "AZ",
                "name": "Arizona"
            },
            {
                "id": "5",
                "code": "AR",
                "name": "Arkansas"
            },
            {
                "id": "12",
                "code": "CA",
                "name": "California"
            },
            {
                "id": "13",
                "code": "CO",
                "name": "Colorado"
            },
            {
                "id": "14",
                "code": "CT",
                "name": "Connecticut"
            },
            {
                "id": "15",
                "code": "DE",
                "name": "Delaware"
            },
            {
                "id": "16",
                "code": "DC",
                "name": "District of Columbia"
            },
            {
                "id": "18",
                "code": "FL",
                "name": "Florida"
            },
            {
                "id": "19",
                "code": "GA",
                "name": "Georgia"
            },
            {
                "id": "21",
                "code": "HI",
                "name": "Hawaii"
            },
            {
                "id": "22",
                "code": "ID",
                "name": "Idaho"
            },
            {
                "id": "23",
                "code": "IL",
                "name": "Illinois"
            },
            {
                "id": "24",
                "code": "IN",
                "name": "Indiana"
            },
            {
                "id": "25",
                "code": "IA",
                "name": "Iowa"
            },
            {
                "id": "26",
                "code": "KS",
                "name": "Kansas"
            },
            {
                "id": "27",
                "code": "KY",
                "name": "Kentucky"
            },
            {
                "id": "28",
                "code": "LA",
                "name": "Louisiana"
            },
            {
                "id": "29",
                "code": "ME",
                "name": "Maine"
            },
            {
                "id": "31",
                "code": "MD",
                "name": "Maryland"
            },
            {
                "id": "32",
                "code": "MA",
                "name": "Massachusetts"
            },
            {
                "id": "33",
                "code": "MI",
                "name": "Michigan"
            },
            {
                "id": "34",
                "code": "MN",
                "name": "Minnesota"
            },
            {
                "id": "35",
                "code": "MS",
                "name": "Mississippi"
            },
            {
                "id": "36",
                "code": "MO",
                "name": "Missouri"
            },
            {
                "id": "37",
                "code": "MT",
                "name": "Montana"
            },
            {
                "id": "38",
                "code": "NE",
                "name": "Nebraska"
            },
            {
                "id": "39",
                "code": "NV",
                "name": "Nevada"
            },
            {
                "id": "40",
                "code": "NH",
                "name": "New Hampshire"
            },
            {
                "id": "41",
                "code": "NJ",
                "name": "New Jersey"
            },
            {
                "id": "42",
                "code": "NM",
                "name": "New Mexico"
            },
            {
                "id": "43",
                "code": "NY",
                "name": "New York"
            },
            {
                "id": "44",
                "code": "NC",
                "name": "North Carolina"
            },
            {
                "id": "45",
                "code": "ND",
                "name": "North Dakota"
            },
            {
                "id": "47",
                "code": "OH",
                "name": "Ohio"
            },
            {
                "id": "48",
                "code": "OK",
                "name": "Oklahoma"
            },
            {
                "id": "49",
                "code": "OR",
                "name": "Oregon"
            },
            {
                "id": "51",
                "code": "PA",
                "name": "Pennsylvania"
            },
            {
                "id": "52",
                "code": "PR",
                "name": "Puerto Rico"
            },
            {
                "id": "53",
                "code": "RI",
                "name": "Rhode Island"
            },
            {
                "id": "54",
                "code": "SC",
                "name": "South Carolina"
            },
            {
                "id": "55",
                "code": "SD",
                "name": "South Dakota"
            },
            {
                "id": "56",
                "code": "TN",
                "name": "Tennessee"
            },
            {
                "id": "57",
                "code": "TX",
                "name": "Texas"
            },
            {
                "id": "58",
                "code": "UT",
                "name": "Utah"
            },
            {
                "id": "59",
                "code": "VT",
                "name": "Vermont"
            },
            {
                "id": "61",
                "code": "VA",
                "name": "Virginia"
            },
            {
                "id": "62",
                "code": "WA",
                "name": "Washington"
            },
            {
                "id": "63",
                "code": "WV",
                "name": "West Virginia"
            },
            {
                "id": "64",
                "code": "WI",
                "name": "Wisconsin"
            },
            {
                "id": "65",
                "code": "WY",
                "name": "Wyoming"
            }
        ]
    },
    "CA": {
        "id": "CA",
        "two_letter_abbreviation": "CA",
        "three_letter_abbreviation": "CAN",
        "full_name_locale": "Canada",
        "full_name_english": "Canada",
        "available_regions": [
            {
                "id": "66",
                "code": "AB",
                "name": "Alberta"
            },
            {
                "id": "67",
                "code": "BC",
                "name": "British Columbia"
            },
            {
                "id": "68",
                "code": "MB",
                "name": "Manitoba"
            },
            {
                "id": "70",
                "code": "NB",
                "name": "New Brunswick"
            },
            {
                "id": "69",
                "code": "NL",
                "name": "Newfoundland and Labrador"
            },
            {
                "id": "72",
                "code": "NT",
                "name": "Northwest Territories"
            },
            {
                "id": "71",
                "code": "NS",
                "name": "Nova Scotia"
            },
            {
                "id": "73",
                "code": "NU",
                "name": "Nunavut"
            },
            {
                "id": "74",
                "code": "ON",
                "name": "Ontario"
            },
            {
                "id": "75",
                "code": "PE",
                "name": "Prince Edward Island"
            },
            {
                "id": "76",
                "code": "QC",
                "name": "Quebec"
            },
            {
                "id": "77",
                "code": "SK",
                "name": "Saskatchewan"
            },
            {
                "id": "78",
                "code": "YT",
                "name": "Yukon Territory"
            }
        ]
    }
}
